/**
 * Constants for skill assessment feature
 */
export const MAX_SKILL_NAME_LENGTH = 50

export const MAX_SKILL_HINT_LENGTH = 300

export const MAX_LEVEL_DESCRIPTION_LENGTH = 150
